<!-- Modal Header -->
<div class="modal-header modal-head">
    <div class="modal-titles">RISULTATO IMPORTING XML RED</div>
</div>

<!-- Modal body -->
<div class="modal-body">

    <div class="row">
        <div class="col">
            <div class="m-3">
                <div class="invalid-feedback" [ngClass]="{'invalid-feedback':data.status !== 'OK'}" style="text-align: center;">
                        <span style="display: block;">
                            {{data.message}}
                        </span>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="data.status === 'OK'">
        <div class="col">
            <div class="m-3">
                <div>
                    <span >
                        <strong>Numero di store rossi creati:</strong> {{data.report.created}}
                    </span>
                </div>
                <div>
                    <span >
                        <strong>Numero di store rossi vecchi eliminati:</strong> {{data.report.deleted}}
                    </span>
                </div>
            </div>
        </div>
    </div>


    <!-- Modal footer -->
    <div class="modal-foot">
        <div class="row my-3 text-center">
            <button type="button" class="btn btn-fw text me-3"
                    (click)="clickButtonSave()">Chiudi
            </button>

        </div>
    </div>
</div>